import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'FetchOptions';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(FetchOptions());
        var tmp_1 = null instanceof FetchOptions();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(getKClass(FetchOptions()), arrayOf([]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
        tmp.key_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FetchOptionsClass;
function FetchOptions() {
  if (FetchOptionsClass === VOID) {
    class $ {
      constructor(requestInit) {
        Companion_getInstance();
        this.requestInit_1 = requestInit;
      }
    }
    initMetadataForClass($, 'FetchOptions');
    FetchOptionsClass = $;
  }
  return FetchOptionsClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1hc2foxl6vgy9,
};
//endregion

//# sourceMappingURL=JsRequestUtils.mjs.map
